//CA2 Slice
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../AxiosInterceptor/axiosInterceptor";
import { AnnualReportDetail } from "../../Table/TableQueryColumn";

const initialState = {
    annualReportData: {
        totalCount: 0,
        page: 0,
        pageSize: 50,
        collectionName: "CocaAnnualReport",
        data: [],
        loading: false,
        error: false,
        lastRefreshedDate: ''
    }
}

export const getCocaAnnualReportDetails = createAsyncThunk('data/GetCocaAnnualReportDetails',
    async (data, { rejectWithValue }) => {
        try {
            let queryCocaAnnualReportDetails =
                `query {
                GetCocaAnnualReportDetails(
                collectionName: "CocaAnnualReport"
                `;

            queryCocaAnnualReportDetails += AnnualReportDetail

            const response = await axiosInstance.post(process.env.REACT_APP_COCAREPORTS,
                JSON.stringify({ query: queryCocaAnnualReportDetails, variables: {} })
            );

            if (response.data.errors && response.data.errors.length > 0) {
                const errorMessages = response.data.errors.map(err => err.message).join(', ');
                return rejectWithValue(errorMessages);
            }

            return JSON.stringify(response);
        } catch (err) {
            return rejectWithValue(err.message || 'Unexpected error');
        }
    }
);

const cocaAnnual2Slice = createSlice({
    name: 'cocaAnnual2',
    initialState,
    reducers: {
        clearData: (state) => {
            state.annualReportData = initialState.annualReportData
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getCocaAnnualReportDetails.pending, (state) => {
                state.annualReportData.loading = true;
                state.annualReportData.error = false;
            })
            .addCase(getCocaAnnualReportDetails.fulfilled, (state, action) => {
                const response = JSON.parse(action.payload);
                state.annualReportData.error = false;
                state.annualReportData.loading = false;
                state.annualReportData.lastRefreshedDate = response?.data?.data?.GetCocaAnnualReportDetails?.lastRefreshedDate ?? '';
                state.annualReportData.data = response?.data?.data?.GetCocaAnnualReportDetails?.data;
            })
            .addCase(getCocaAnnualReportDetails.rejected, (state, action) => {
                state.annualReportData.loading = false;
                state.annualReportData.error = true;
            })
    }
})

export const { clearData } = cocaAnnual2Slice.actions;
export default cocaAnnual2Slice.reducer